import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID,EventEmitter,Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'

import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { StateService } from '../../../../../services/state.service'
import { DialogService } from '../../../../../services/dialog-service.service'
import { AppService } from '../../../../../services/app.service'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

const KEY = 'groupe-dialog'

@Component({
	selector: 'atyl-groupe-dialog',
	templateUrl: './groupe-dialog.component.html',
	styleUrls: ['./groupe-dialog.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/content/general/groupe',
	key: KEY,
})
export class GroupeDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any

	user:any;
	
	groupesTiers:any={};
	
	groupes:any[]=[];
	personnels:any[]=[];
	personnelInput:any;
	
	selectGroup:boolean[]=[];
	selectPersonnel:boolean[]=[];
	
	types:any[]=[];
	
	dossier:any;
     
	id:any;

    @Output() lengthGroupe: EventEmitter<number> = new EventEmitter<number>();
    
   ispersonnel:boolean=true;
	    
     
	constructor(
		public dialogRef: MatDialogRef<GroupeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,			
		changeDetectorRef: ChangeDetectorRef,
		private tiersService: AppService,
		dialogService: DialogService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		if (this.data.id!=undefined && this.data.id ) {
				this.id = this.data.id;
		}
		
		if (this.data.personnel!=undefined ) {
			this.ispersonnel = this.data.personnel;
		}
		
		if (this.data.dossier!=undefined && this.data.dossier ) {
			this.dossier = this.data.dossier;
		}
		if (this.data.groupes!=undefined && this.data.groupes ) {
			let gts:any={};
			for(let i:number=0;i<this.data.groupes.length;i++) {
				let gt:any=this.data.groupes[i];
				if (gt.groupe!=undefined && gt.groupe.ID!=undefined)
					gts[gt.groupe.ID]=gt;
				
			}
			
			this.groupesTiers = gts;
		}
		if (this.data.user!=undefined && this.data.user ) {
			this.user = this.data.user;
		}
		if (this.data.types!=undefined && this.data.types ) {
				this.types = this.data.types;
		}
			
		this.loadGroupe();		
				
	}

	detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
	
	loadGroupe() {
		
		let _opts:any={
			   
		}
		let id:any;
			   
	   if (this.user!=undefined) {
		if (this.dossier!=undefined 
			&& this.dossier!=undefined 
			 && this.dossier.ID!=undefined ) {
		   	 _opts["personnel"]=true;
		   }
	   }
	   this.groupes=[];
	   this.personnels=[];
	   
	   this.selectGroup=[];
	   this.selectPersonnel=[];
		  
		this.tiersService.getGroupeList(this.types,_opts).subscribe(
			   (res: JSONRpcResponse) => {
					console.log("GroupeComponent loaded",res);
					if (res.result 
						&& res.result!=undefined
					) {
						for(let i:number=0;i<res.result.length;i++) {
							let grp:any=res.result[i];
							grp.added=(grp.ID!=undefined && this.groupesTiers[grp.ID]!=undefined);
							if (grp.propritaire) {
								this.personnels.push(grp);
								this.selectPersonnel.push(grp.added);
							}
							else {
								this.groupes.push(grp);
								this.selectGroup.push(grp.added);
							}
							
						}
						
						this.selectPersonnel.push(false);
						
						
						this.detectChanges();
					}
						
				}
		   );
	}
    
	hexToRgbA(hex: string, alpha: any = 255) {
			let color: any
			let newAlpha = Number.parseInt(alpha, 10)

			if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
				color = hex.substring(1).split('')
				if (color.length == 3) {
					color = [color[0], color[0], color[1], color[1], color[2], color[2]]
				}
				color = '0x' + color.join('')
				return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')'
			}
	}
	
	filledText(event:any) {
		
		this.selectPersonnel[this.personnels.length]= (this.personnelInput!=undefined && this.personnelInput.length>0 );
		this.detectChanges()
	}
	
	saveGroupe(event: MouseEvent) {
		console.log("GroupeComponent save",this.selectPersonnel,this.selectGroup,this.personnelInput)
		let grpSave:any[]=[];
		for(let i:number=0;i<this.groupes.length;i++) {
			if (this.selectGroup[i]!=undefined
				  ) {
					this.groupes[i].added=this.selectGroup[i];
					grpSave.push(this.groupes[i]);
				}
		}
		
		for(let i:number=0;i<this.personnels.length;i++) {
			if (this.selectPersonnel[i]!=undefined
				 ) {
					this.personnels[i].added=this.selectPersonnel[i];
					grpSave.push(this.personnels[i]);
				}
		}
		let _opts={
			
			groupes:grpSave
		};
		
		if (this.selectPersonnel[this.personnels.length]  && this.personnelInput.length>0)
			_opts["personnel"]=this.personnelInput;
		
		console.log("GroupeComponent before save",this.id,_opts)
		this.tiersService.setGroupe(this.id,_opts).subscribe(
					   (res: JSONRpcResponse) => {
							console.log("GroupeComponent saved",res);
							if (res.result 
								&& res.result!=undefined
							) {
								
								this.dialogRef.close();
								
								this.detectChanges();
							}
								
						}
		);
	}
	
	
}
